// this file is generated by update_shopify_store_data.py at 2025-12-03 20:30:06.762904
var courses = [];